import { render, staticRenderFns } from "./OfferIcon.vue?vue&type=template&id=4b90f983&"
import script from "./OfferIcon.vue?vue&type=script&lang=ts&"
export * from "./OfferIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports